

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 PRO React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import FMPFooter from "examples/Footers/FMPFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

function Privacy() {
  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "internal",
          route: "/pages/ajuda/contate-nos",
          label: "Contate-nos",
          color: "dark",
        }}
        sticky
      />
      <MKBox component="section" pt={20} pb={12}>
        <Container>
          <Grid container justifyContent="center">
            <Grid item xs={12}>
              <Card>
                <MKBox
                  variant="gradient"
                  bgColor="dark"
                  borderRadius="lg"
                  coloredShadow="dark"
                  p={3}
                  mt={-3}
                  mx={2}
                >
                  <MKTypography variant="h3" color="white">
                    Política de Privacidade
                  </MKTypography>
                  <MKTypography variant="body2" color="white" opacity={0.8} fontSize="small">
                    Última atualização: 10 de julho de 2025
                  </MKTypography>
                </MKBox>
                <MKBox pb={6} px={6}>
                  <MKTypography variant="h5" mt={6} mb={3}>
                    Introdução
                  </MKTypography>
                  <MKTypography variant="body2" color="text">
                    A FMP Soluções é uma empresa brasileira especializada em soluções de segurança cibernética e consultoria empresarial, 
                    comprometida com a ética, a segurança da informação e o respeito à privacidade de seus clientes, colaboradores, 
                    parceiros e visitantes de suas plataformas.
                    <br />
                    Para garantir a confidencialidade e a integridade dos dados pessoais, seguimos rigorosamente as diretrizes da Lei Geral de 
                    Proteção de Dados Pessoais (Lei nº 13.709/2018 – LGPD), que regula o tratamento de dados pessoais com base 
                    nos princípios da boa-fé, transparência, necessidade e segurança.
                    <br />
                    Esta política explica como tratamos seus dados pessoais, quais informações coletamos, por que as utilizamos, com quem podemos 
                    compartilhá-las e como você pode exercer seus direitos.

                  </MKTypography>
                  <MKTypography variant="h5" mt={6} mb={3}>
                    O que são Dados Pessoais?
                  </MKTypography>
                  <MKTypography variant="body2" color="text">
                    Dados pessoais são todas as informações que identificam ou podem identificar uma pessoa natural, direta ou indiretamente. 
                    Isso inclui:
                  </MKTypography>
                  <MKBox component="ul" my={3} ml={6}>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Nome, e-mail e número de telefone;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Endereço físico ou IP;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Informações profissionais ou financeiras;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Dados de localização, preferências de navegação, entre outros.
                      </MKTypography>
                    </MKBox>
                  </MKBox>
                  
                 
                  <MKTypography variant="h5" mt={6} mb={3}>
                    Quais Dados Coletamos?
                  </MKTypography>
                  <MKTypography variant="body2" color="text">
                    A FMP Soluções coleta dados pessoais conforme a necessidade dos serviços prestados. Exemplos incluem:
                  </MKTypography>
                  <MKBox component="ul" my={3} ml={6}>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Dados cadastrais: nome, e-mail, telefone, CPF, CNPJ, endereço;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Dados de uso: páginas acessadas, IP, geolocalização, dispositivo utilizado, tipo de navegador;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Dados profissionais: cargo, empresa onde trabalha, currículo, histórico profissional;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Dados sensíveis (apenas com consentimento): podem incluir informações sobre saúde, orientação, ou origem racial, quando estritamente necessárias.
                      </MKTypography>
                    </MKBox>
                  </MKBox>
                  <MKTypography variant="body2" color="text">
                    A coleta é sempre feita de forma transparente, e você será informado sobre os motivos e propósitos do uso.
                  </MKTypography>
                  

                  <MKTypography variant="h5" mt={6} mb={3}>
                    Para Que Usamos Seus Dados?
                  </MKTypography>
                  <MKTypography variant="body2" color="text">
                    Os dados são utilizados para:
                  </MKTypography>
                  <MKBox component="ul" my={3} ml={6}>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Prestar serviços contratados ou respondê-lo em solicitações;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Fornecer suporte e atendimento;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Realizar ações de marketing, somente com seu consentimento;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Realizar análises estatísticas, melhorias nos serviços, e personalização da experiência;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Cumprir obrigações legais, regulatórias ou judiciais;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Garantir a segurança das plataformas digitais e prevenir fraudes;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Conduzir processos seletivos, quando aplicável.
                      </MKTypography>
                    </MKBox>
                  </MKBox>


                  <MKTypography variant="h5" mt={6} mb={3}>
                    Como Coletamos os Dados
                  </MKTypography>
                  <MKTypography variant="body2" color="text">
                    A FMP Soluções coleta dados por:
                  </MKTypography>
                  <MKBox component="ul" my={3} ml={6}>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Formulários em nosso site;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Contratos assinados física ou digitalmente;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Atendimento por telefone, e-mail ou chat;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Cookies e tecnologias semelhantes;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Aplicações internas e sistemas de gestão.
                      </MKTypography>
                    </MKBox>
                  </MKBox>


                  <MKTypography variant="h5" mt={6} mb={3}>
                    Compartilhamento e Armazenamento de Dados
                  </MKTypography>
                  <MKTypography variant="body2" color="text">
                    Compartilhamento ocorre somente quando necessário, com:
                  </MKTypography>
                  <MKBox component="ul" my={3} ml={6}>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Prestadores de serviços contratados, mediante contratos com cláusulas de confidencialidade e segurança;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Autoridades públicas, mediante obrigações legais ou judiciais;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Em processos de fusão, aquisição ou reestruturação, respeitando a continuidade da proteção dos dados.
                      </MKTypography>
                    </MKBox>
                  </MKBox>
                   <MKTypography variant="body2" color="text">
                    <text fontWeight="heavy">Armazenamento: </text>Os dados são guardados em ambientes controlados, com mecanismos de criptografia, controle de acesso, 
                    autenticação e backup. A FMP Soluções pode usar servidores localizados no Brasil ou em países que ofereçam nível de 
                    proteção equivalente à LGPD.
                  </MKTypography>


                  <MKTypography variant="h5" mt={6} mb={3}>
                    Segurança dos Dados
                  </MKTypography>
                  <MKTypography variant="body2" color="text">
                    A FMP Soluções adota medidas técnicas e administrativas rigorosas para proteger os dados contra acessos não autorizados, destruição, 
                    perda, alteração ou qualquer forma de tratamento inadequado:
                  </MKTypography>
                  <MKBox component="ul" my={3} ml={6}>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Criptografia de dados;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Firewalls e monitoramento;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Controle de acesso com autenticação;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Registro e auditoria de logs;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Política de segurança da informação;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Treinamentos internos sobre privacidade.
                      </MKTypography>
                    </MKBox>
                  </MKBox>


                  <MKTypography variant="h5" mt={6} mb={3}>
                    O que São Cookies?
                  </MKTypography>
                  <MKTypography variant="body2" color="text">
                    Cookies são pequenos arquivos de texto armazenados em seu navegador quando você visita um site. Eles ajudam a identificar seu 
                    dispositivo, lembrar suas preferências e melhorar sua navegação.
                    <br/>
                    Utilizamos cookies para:
                  </MKTypography>
                  <MKBox component="ul" my={3} ml={6}>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Permitir funcionalidades essenciais do site;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Analisar o uso do site (cookies analíticos);
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Personalizar conteúdo e lembrar preferências (cookies funcionais);
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Melhorar campanhas de marketing (com sua autorização).
                      </MKTypography>
                    </MKBox>
                  </MKBox>
                  <MKTypography variant="body2" color="text">
                    Você pode configurar seu navegador para bloquear ou excluir cookies a qualquer momento. No entanto, isso pode 
                    limitar certas funcionalidades do site.
                  </MKTypography>

                  <MKTypography variant="h5" mt={6} mb={3}>
                    Direitos dos Titulares de Dados
                  </MKTypography>
                  <MKTypography variant="body2" color="text">
                    De acordo com a LGPD, você tem direitos garantidos sobre seus dados pessoais:
                  </MKTypography>
                  <MKBox component="ol" my={3} ml={6}>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Confirmação de tratamento: saber se tratamos seus dados;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Acesso: obter uma cópia dos dados pessoais tratados;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Correção: solicitar correção de dados incompletos ou desatualizados;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Anonimização, bloqueio ou eliminação: para dados desnecessários ou excessivos;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Portabilidade: transferir seus dados a outro fornecedor de serviço;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Eliminação de dados tratados com consentimento;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Informação sobre compartilhamentos;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Revogação do consentimento;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Oposição: se discordar do tratamento baseado em legítimo interesse.
                      </MKTypography>
                    </MKBox>
                  </MKBox>
                   <MKTypography variant="body2" color="text">
                    Esses direitos podem ser exercidos gratuitamente, por meio de solicitação formal ao nosso canal de atendimento ao titular, descrito abaixo.
                  </MKTypography>


                  <MKTypography variant="h5" mt={6} mb={3}>
                    Prazo de Retenção dos Dados
                  </MKTypography>
                  <MKTypography variant="body2" color="text">
                    Os dados são mantidos apenas pelo tempo necessário para:
                  </MKTypography>
                  <MKBox component="ul" my={3} ml={6}>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Cumprir finalidades informadas;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Atender exigências legais ou regulatórias;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Proteger direitos da FMP Soluções e dos titulares.
                      </MKTypography>
                    </MKBox>
                  </MKBox>
                  <MKTypography variant="body2" color="text">
                      Dados de localização, preferências de navegação, entre outros.
                  </MKTypography>

                  <MKTypography variant="h5" mt={6} mb={3}>
                    Transferência Internacional de Dados
                  </MKTypography>
                  <MKTypography variant="body2" color="text">
                    Quando necessário, seus dados podem ser transferidos para fora do Brasil, observando:
                  </MKTypography>
                  <MKBox component="ul" my={3} ml={6}>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Países com legislação de proteção de dados equivalente à LGPD;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Adoção de cláusulas contratuais específicas;
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Garantia de medidas de segurança e privacidade.
                      </MKTypography>
                    </MKBox>
                  </MKBox>


                  <MKTypography variant="h5" mt={6} mb={3}>
                    Alterações na Política de Privacidade
                  </MKTypography>
                  <MKTypography variant="body2" color="text">
                    A FMP Soluções pode atualizar esta política periodicamente. Caso haja mudanças relevantes, 
                    comunicaremos por meio dos canais oficiais (site, e-mail, aplicativos).
                  </MKTypography>

                  <MKTypography variant="h5" mt={6} mb={3}>
                    Canal de Atendimento e Encarregado de Dados (DPO)
                  </MKTypography>
                  <MKTypography variant="body2" color="text">
                    Você pode tirar dúvidas, fazer solicitações ou exercer seus direitos por meio do canal oficial:
                  </MKTypography>
                  <MKBox component="ul" my={3} ml={6}>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        E-mail do DPO: dpo@fmpsolucoes.com.br
                      </MKTypography>
                    </MKBox>
                    <MKBox component="li">
                      <MKTypography variant="body2" color="text" fontWeight="regular">
                        Endereço físico: Rua Exemplo, 123 – Bairro – Cidade/UF – Brasil
                      </MKTypography>
                    </MKBox>
                  </MKBox>

                  <MKTypography variant="h5" mt={6} mb={3}>
                    Compromisso com a Privacidade
                  </MKTypography>
                  <MKTypography variant="body2" color="text" fontWeight="regular">
                    A privacidade é um direito fundamental. A FMP Soluções reafirma seu compromisso de tratar seus dados pessoais com responsabilidade, 
                    transparência e segurança, sempre com base na lei e no respeito ao titular.
                  </MKTypography>
                </MKBox>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </MKBox>
      <MKBox pt={6} px={1} mt={6}>
        <FMPFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Privacy;
